module.exports = __webpack_public_path__ + "img/justina-ireland.bc910b29.png";